import Box from '@mui/material/Box'
import { MobileLayout } from '../../components/layout/mobileLayout'
import HomeProvider from './provider'
import { useHomeContext } from './context'
import Hero from './components/hero'
import Benefits from './components/benefits'
import Form from './components/form'
import Success from './components/success'

// Decorative circles component
const DecorativeCircles = () => (
  <>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 302,
        height: 302,
        borderRadius: '50%',
        backgroundColor: '#DCD1F2',
        opacity: 0.5,
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        top: 20,
        right: 20,
        width: 260,
        height: 260,
        borderRadius: '50%',
        backgroundColor: '#B9A4E6',
        opacity: 0.3,
      }}
    />
  </>
)

// Landing view: Hero + Benefits + Form
const LandingView = () => (
  <Box sx={{ position: 'relative', minHeight: '100vh', padding: '10px' }}>
    <DecorativeCircles />
    <Hero />
    <Benefits />
    <Form />
  </Box>
)

// Success view
const SuccessView = () => (
  <Box sx={{ position: 'relative', minHeight: '100vh', padding: '10px' }}>
    <DecorativeCircles />
    <Success />
  </Box>
)

const HomeInner = () => {
  const { currentView } = useHomeContext()

  if (currentView === 'success') {
    return <SuccessView />
  }

  return <LandingView />
}

const HomeContainer = () => (
  <HomeProvider>
    <MobileLayout>
      <HomeInner />
    </MobileLayout>
  </HomeProvider>
)

export default HomeContainer
